import { Trans, useTranslation } from 'react-i18next'

import { PropertyManager, useDeletePropertyManager } from '@/api/property-managers'
import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'
import { toastFactory } from '@/factories'
import { getApiErrorMessage } from '@/utils/error'

import { getPropertyManagerFullName } from '../property-managers.utils'

interface DeletePropertyManagerConfirmationPopupProps {
  onClose: VoidFunction
  propertyManager: PropertyManager
}

export const DeletePropertyManagerConfirmationPopup = ({
  onClose,
  propertyManager,
}: DeletePropertyManagerConfirmationPopupProps) => {
  const { t } = useTranslation(['organisation'])
  const { mutateAsync: deletePropertyManager } = useDeletePropertyManager()

  const name = getPropertyManagerFullName(propertyManager)

  const handleConfirm = async () => {
    try {
      await deletePropertyManager(propertyManager.id)
      toastFactory.success(t('organisation:propertyManagers.deleteConfirmation.success', { name }))
    } catch (error) {
      toastFactory.error(getApiErrorMessage(error))
    }
    onClose()
  }

  return (
    <ConfirmationPopup
      confirmText={t('organisation:propertyManagers.deleteConfirmation.confirm')}
      title={t('organisation:propertyManagers.deleteConfirmation.title')}
      variant="danger"
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <Typography>
        <Trans
          components={[<strong key="name" />]}
          i18nKey="organisation:propertyManagers.deleteConfirmation.body"
          t={t}
          values={{ name }}
        />
      </Typography>
    </ConfirmationPopup>
  )
}
